export const FEDRAL_DATASETS_AGOL_GROUP =
    'https://www.arcgis.com/home/group.html?id=8c90888d825d440a9e4754fda9e4e92e';
